import { Users } from '@/api/Users';
import { RoleRepresentation } from '@/api/data-contracts';
import useUploadProgressService from '@/shared/api/uploadProgress.service';

const usePermissionsService = () => {
  const usersApi = useUploadProgressService(Users);

  const getPermissions = async (signal: AbortSignal | undefined): Promise<RoleRepresentation[]> => {
    // @ts-ignore
    const { data } = await usersApi.getPermissions({ signal, body: {} });
    return data;
  };

  const getLevels = async (
    signal: AbortSignal | undefined,
  ): Promise<Record<string, RoleRepresentation[]>> => {
    // @ts-ignore
    const { data } = await usersApi.getLevels({ signal, body: {} });
    return data;
  };

  return { getPermissions, getLevels };
};

export default usePermissionsService;
